import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial-forgot-password',
  templateUrl: './tutorial-forgot-password.component.html',
  styleUrls: ['./tutorial-forgot-password.component.css']
})
export class TutorialForgotPasswordComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}